// extracted by mini-css-extract-plugin
module.exports = {"module":"ClockAssignmentsList_module__2xk7X","content":"ClockAssignmentsList_content__39wDf"};